'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubtitleStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fontStyle = function fontStyle(_ref) {
  var colorScheme = _ref.colorScheme,
      themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.breadcrumbs.item.subtitle;

  var marginTop = path.marginTop,
      fontSize = path.fontSize,
      lineHeight = path.lineHeight,
      fontWeight = path.fontWeight,
      textTransform = path.textTransform;


  return (0, _styledComponents.css)(['margin-top:', ';font-size:', ';line-height:', ';font-weight:', ';text-transform:', ';color:', ';'], (0, _reactackleCore.getValueString)(marginTop), (0, _reactackleCore.getValueString)(fontSize), lineHeight, fontWeight, textTransform, path.colorScheme[colorScheme].color);
};

var SubtitleStyled = exports.SubtitleStyled = _styledComponents2.default.div.withConfig({
  displayName: 'SubtitleStyled'
})(['', ''], fontStyle);


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-breadcrumbs/dist/BreadcrumbsItem/styles/SubtitleStyled.js
// module id = 551
// module chunks = 0